// extracted by mini-css-extract-plugin
var _1 = "EntityTabInhabitants-moduleEntityTabInhabitants__SIzn7";
var _2 = "EntityTabInhabitants-moduleactions__XW1Pj";
var _3 = "EntityTabInhabitants-moduleemptyPage__zyfZi";
var _4 = "EntityTabInhabitants-modulefilterBar__fhx37";
var _5 = "EntityTabInhabitants-modulepagination__f8LlR TablePagination-moduleTablePagination__cupJ7";
var _6 = "EntityTabInhabitants-modulesubTabs__O1LNc EntityTabSubTabs-moduleEntityTabSubTabs__c4_31";
var _7 = "EntityTabInhabitants-moduletoolbar__DdFjv";
export { _1 as "EntityTabInhabitants", _2 as "actions", _3 as "emptyPage", _4 as "filterBar", _5 as "pagination", _6 as "subTabs", _7 as "toolbar" }
